import type { ReferenceWordMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import {
  WordDictionarySurfaceHeader,
  WordDictionarySurfaceBody,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.dictionary.__sections.overview";
import { useMorphemeInfoPanelSentencesWordSections } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.sentences";
import { DictionaryTopSheet } from "#dictionary-top-sheet";
import { WordDictionaryOccurrences } from "#word-dictionary-occurrences";
import { Pressable } from "@-/com.npmjs.react-native";
import { SurfaceHeader } from "@-/dev.improve.haniverse.components.ui.surface";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";

export function WordDictionaryTopSheet({ wordCard }: { wordCard: ReferenceWordMorphemeSlice }) {
  const examples = useMorphemeInfoPanelSentencesWordSections({ wordCard });
  return (
    <DictionaryTopSheet
      contextSections={examples}
      expandedContent={<WordDictionaryOccurrences word={wordCard.word} />}
      renderExpandedHeader={(expand) => (
        <SurfaceHeader className="py-2">
          <Pressable
            accessibilityLabel="Reveal word occurrences"
            accessibilityRole="button"
            className="flex-row items-center gap-x-2"
            onPress={expand}
          >
            <Text className="text-xs font-semibold">Appears in</Text>
            <Text className="text-[11px] text-muted-foreground">Swipe down to reveal</Text>
          </Pressable>
        </SurfaceHeader>
      )}
      kind="word"
      overviewContent={<WordDictionarySurfaceBody wordCard={wordCard} />}
      renderHeader={(onLayout) => (
        <WordDictionarySurfaceHeader compact onLayout={onLayout} wordCard={wordCard} />
      )}
    />
  );
}
